/**
 * This utility class helps in converting short form week days to long form week days, and provides
 * arrays for iterating over workdays.
 */
export class WeekDays {
  static mon = 'Monday';
  static tue = 'Tuesday';
  static wed = 'Wednesday';
  static thu = 'Thursday';
  static fri = 'Friday';
  static sat = 'Saturday';
  static sun = 'Sunday';
  static daysShort = [
    'mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun',
  ];
  static daysFull = WeekDays.daysShort.map(day => WeekDays[day]);
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/utils/weekdays.js